import React from 'react';

interface GoogleMapProps {
  address: string;
  gmapLink?: string | null;
}

const GoogleMap: React.FC<GoogleMapProps> = ({ address, gmapLink }) => {
  // Get API key from environment variable (optional)
  const googleMapsApiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

  // If gmapLink is provided, use it directly
  if (gmapLink) {
    return (
      <iframe
        src={gmapLink}
        className="ground-map-iframe"
        title="Ground Location Map"
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    );
  }

  // If we have an API key, use Google Maps Embed API
  if (googleMapsApiKey) {
    const encodedAddress = encodeURIComponent(address);
    const embedUrl = `https://www.google.com/maps/embed/v1/place?key=${googleMapsApiKey}&q=${encodedAddress}`;
    
    return (
      <iframe
        src={embedUrl}
        className="ground-map-iframe"
        title="Ground Location Map"
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    );
  }

  // Fallback: Create a clickable Google Maps link (works without API key)
  const encodedAddress = encodeURIComponent(address);
  const mapsSearchUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

  return (
    <div className="ground-map-fallback">
      <a 
        href={mapsSearchUrl} 
        target="_blank" 
        rel="noopener noreferrer"
        className="ground-map-link"
      >
        <div className="ground-map-placeholder-content">
          <div className="map-icon">📍</div>
          <p className="map-placeholder-text">Click to view location on Google Maps</p>
          <p className="map-address">{address}</p>
        </div>
        <div className="ground-map-overlay">
          <span>View on Google Maps</span>
        </div>
      </a>
    </div>
  );
};

export default GoogleMap;

